import { ITextAsProps } from '../../../../../sp-types/routeDetailsType';
import React from 'react';

export const InputRouteDetailsPlainText: React.FC<ITextAsProps> = ({ text, update = () => {} }) => {
  return (
    <textarea
      className="flex flex-1 text-sm text-secondary w-full  overflow-auto"
      value={text}
      onChange={(event) => update({ text: event.target.value })}
    />
  );
};
